import { instanceOEF, segundaVersaoOEF } from './api'

export const postUpgradePlanoAPI = dadosUpgrade => {
  return instanceOEF.post(
    `${segundaVersaoOEF}/upgrade-assinatura`,
    { ...dadosUpgrade }
  )
}
